import React, { useState } from 'react'
import styled from 'styled-components'
import useEsignDraftPoll from '../hooks/useEsignDraftPoll'
import EyeIcon from './icons/eye'
import PaperPlaneIcon from './icons/paper-plane'
import FileXMarkIcon from './icons/file-x-mark'
import SignatureIcon from '../icons/signature'
import SendReminderModal from './modals/send-reminder'
import CancelModal from './modals/cancel'
import StatusModal from './modals/status'
import ContinueModal from './modals/continue'
import { EsignVendors, DocumentEsignStatuses } from '../constants'
import { useDocumentsConfig } from '../../contexts/DocumentsConfigContext'

const ContainerElement = styled.div`
  background-color: #ebf5fa;
  padding: 0.5rem;
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  margin: 0.5rem 0;
`

const OptionsWrapperElement = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const OptionContainerElement = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  &:hover {
    cursor: pointer;
    p {
      text-decoration: underline;
    }
  }
`

const OptionTextElement = styled.p`
  font-size: 0.8rem;
  font-weight: 200;
  margin: 0;
  color: #2e8ab8;
`

function SignatureRequests({
  documentId,
  esignVendor,
  documentKey,
  esignStatus,
}) {
  const [showSendReminderModal, setShowSendReminderModal] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [showStatusModal, setShowStatusModal] = useState(false)
  const [showContinueModal, setShowContinueModal] = useState(false)
  const { docusignServiceBaseUrl } = useDocumentsConfig()

  const isDraft =
    esignVendor === EsignVendors.DocuSign &&
    esignStatus === DocumentEsignStatuses.draft

  useEsignDraftPoll(documentId, isDraft)

  return (
    <>
      <ContainerElement>
        <div />
        <OptionsWrapperElement>
          {!isDraft && (
            <>
              <OptionContainerElement onClick={() => setShowStatusModal(true)}>
                <EyeIcon />
                <OptionTextElement>View eSign status</OptionTextElement>
              </OptionContainerElement>
              <OptionContainerElement
                onClick={() => setShowSendReminderModal(true)}
              >
                <PaperPlaneIcon />
                <OptionTextElement>Send reminder</OptionTextElement>
              </OptionContainerElement>
            </>
          )}
          <OptionContainerElement onClick={() => setShowCancelModal(true)}>
            <FileXMarkIcon />
            <OptionTextElement>Cancel eSign request</OptionTextElement>
          </OptionContainerElement>
          {isDraft && (
            <OptionContainerElement onClick={() => setShowContinueModal(true)}>
              <SignatureIcon stroke="#56565A" />
              <OptionTextElement>Continue eSign request</OptionTextElement>
            </OptionContainerElement>
          )}
        </OptionsWrapperElement>
      </ContainerElement>
      {showSendReminderModal && (
        <SendReminderModal
          documentId={documentId}
          esignVendor={esignVendor}
          docusignServiceBaseUrl={docusignServiceBaseUrl}
          documentKey={documentKey}
          onClose={() => setShowSendReminderModal(false)}
        />
      )}
      {showCancelModal && (
        <CancelModal
          documentId={documentId}
          esignVendor={esignVendor}
          docusignServiceBaseUrl={docusignServiceBaseUrl}
          documentKey={documentKey}
          onClose={() => setShowCancelModal(false)}
        />
      )}
      {showStatusModal && (
        <StatusModal
          documentId={documentId}
          esignVendor={esignVendor}
          docusignServiceBaseUrl={docusignServiceBaseUrl}
          documentKey={documentKey}
          onClose={() => setShowStatusModal(false)}
        />
      )}
      {showContinueModal && (
        <ContinueModal
          documentKey={documentKey}
          docusignServiceBaseUrl={docusignServiceBaseUrl}
          onClose={() => setShowContinueModal(false)}
        />
      )}
    </>
  )
}

export default SignatureRequests
